export default __webpack_public_path__ + "static/media/advanced-django-roadmap.59c3c6ff.png";